// src/app/i18n/translate-loader.factory.ts
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';

// Appends ?v=<build id> so each release fetches fresh i18n JSON
export function HttpLoaderFactory(http: HttpClient) {
const v = environment.buildVersion || 'dev';
  return new TranslateHttpLoader(http, '/assets/i18n/', `.json?v=${v}`);
}
